// extracted by mini-css-extract-plugin
export default {"btop":"_170c15736c bd71845d1b _1f89dd7943","icon":"_950943b1d9 _4ba808b81a","btoppink":"f2def3ae29 _81280358af"};